import apiConfig from "@/config/apiConfig";

const rootPath = apiConfig.companyApi;

export const sys_policy = {
  isFillIn: rootPath + "/enterpriseOperatingIncome/isFillIn/",   //  根据年份判断是否做过积分制
  getYearData: rootPath + "/subsidyTypeReleaseTime/getSubsidyYear",  // 获取年份下拉
  isAllow: rootPath + "/subsidyTypeReleaseTime/isAllowAddData",    // 验证是否可以添加数据
  getMoban: rootPath + "/subsidyTypeReleaseTime/promiseFile",    // 获取承诺书模板
  ziliaoUpdate: rootPath + "/subsidyCommonFile/saveOrUpdate",  // 公共资料维护新增修改
  ziliaoDetail: rootPath + "/subsidyCommonFile/detail",   //公共资料维护详情
  ziliaoDownload: rootPath + "/subsidyCommonFile/exportPdfData", // 整合公共资料pdf下载
  getErCode: rootPath + "/subsidyCommonFile/detailQr",  // 获取微信扫码进群的二维码
}

// 专利授权补贴
export const sys_intellectualsubsidy = {
  pageList: rootPath + "/subsidyIntellectualProperty/pageList", // 列表
  saveupdate: rootPath + "/subsidyIntellectualProperty/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/subsidyIntellectualProperty/remove/',   // 删除
  detail: rootPath + "/subsidyIntellectualProperty/detail",   // 获取详情
  commitUrl: rootPath + "/subsidyIntellectualProperty/submit",   // 提交
}

// 高新技术企业补贴
export const sys_highTechEnterprises = {
  pageList: rootPath + "/subsidyHighTechEnterprise/pageList", // 列表
  saveupdate: rootPath + "/subsidyHighTechEnterprise/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/subsidyHighTechEnterprise/remove/',   // 删除
  detail: rootPath + "/subsidyHighTechEnterprise/detail",   // 获取详情
  commitUrl: rootPath + "/subsidyHighTechEnterprise/submit",   // 提交
  getHighTechCode: rootPath + "/enterpriseOperatingIncome/fetchEnterpriseNumber", // 获取积分制填写的高企编号
}

// 中介机构补贴
export const sys_intermediarysubsidy = {
  pageList: rootPath + "/subsidyIntermediaryAgency/pageList", // 列表
  saveupdate: rootPath + "/subsidyIntermediaryAgency/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/subsidyIntermediaryAgency/remove/',   // 删除
  detail: rootPath + "/subsidyIntermediaryAgency/detail",   // 获取详情
  commitUrl: rootPath + "/subsidyIntermediaryAgency/submit",   // 提交
}

// 双创载体培育高企补贴
export const sys_innovationsubsidy = {
  pageList: rootPath + "/massEntrepreneurshipCarrier/pageList", // 列表
  saveupdate: rootPath + "/massEntrepreneurshipCarrier/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/massEntrepreneurshipCarrier/remove/',   // 删除
  detail: rootPath + "/massEntrepreneurshipCarrier/detail",   // 获取详情
  commitUrl: rootPath + "/massEntrepreneurshipCarrier/submit",   // 提交
}

// 资金追踪
export const sys_fundsTracking = {
    pageList: rootPath + "/web/enterpriseFundTracking/queryToPage", // 列表
    saveupdate: rootPath + "/web/enterpriseFundTracking/saveOrUpdate", // 新增,编辑
    updateData: rootPath + "/web/enterpriseFundTracking/updateData", // 新增,编辑
    ziliaoDownload: rootPath + "/web/enterpriseFundTracking/exportFundTrackingPdf",//下载模版
    detail: rootPath + "/web/enterpriseFundTracking/detail",//下载模版
}

// 双软认证补贴
export const sys_certificationsubsidy = {
  pageList: rootPath + "/subsidyDualSoftAuthentication/pageList", // 列表
  saveupdate: rootPath + "/subsidyDualSoftAuthentication/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/subsidyDualSoftAuthentication/remove/',   // 删除
  detail: rootPath + "/subsidyDualSoftAuthentication/detail",   // 获取详情
  commitUrl: rootPath + "/subsidyDualSoftAuthentication/submit",   // 提交
}

// 科技奖项补贴
export const sys_technologyawards = {
  pageList: rootPath + "/scienceTechnologyAwards/pageList", // 列表
  saveupdate: rootPath + "/scienceTechnologyAwards/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/scienceTechnologyAwards/remove/',   // 删除
  detail: rootPath + "/scienceTechnologyAwards/detail",   // 获取详情
  commitUrl: rootPath + "/scienceTechnologyAwards/submit",   // 提交
}

// 区级创新券兑现
export const sys_innovationvouchers = {
  pageList: rootPath + "/districtLevelInnovationVoucher/pageList", // 列表
  saveupdate: rootPath + "/districtLevelInnovationVoucher/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/districtLevelInnovationVoucher/remove/',   // 删除
  detail: rootPath + "/districtLevelInnovationVoucher/detail",   // 获取详情
  commitUrl: rootPath + "/districtLevelInnovationVoucher/submit",   // 提交
}

// 科技研发类平台补贴
export const sys_platformssubsidy = {
  pageList: rootPath + "/researchDevelopmentPlatform/pageList", // 列表
  saveupdate: rootPath + "/researchDevelopmentPlatform/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/researchDevelopmentPlatform/remove/',   // 删除
  detail: rootPath + "/researchDevelopmentPlatform/detail",   // 获取详情
  commitUrl: rootPath + "/researchDevelopmentPlatform/submit",   // 提交
}

// 知识产权管理
export const sys_enterpriseIntellectual = {
  pageList: rootPath + "/enterpriseIntellectual/pageList", // 列表
  saveOrUpdate: rootPath + "/enterpriseIntellectual/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseIntellectual/remove/',   // 删除
  detail: rootPath + "/enterpriseIntellectual/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseIntellectual/submit",   // 提交
}

// 研发机构补贴
export const sys_developmentsubsidy = {
  pageList: rootPath + "/enterpriseSubsidyResearchMechanism/pageList", // 列表
  saveupdate: rootPath + "/enterpriseSubsidyResearchMechanism/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseSubsidyResearchMechanism/remove/',   // 删除
  detail: rootPath + "/enterpriseSubsidyResearchMechanism/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseSubsidyResearchMechanism/submit",   // 提交
}

// 科技项目补贴
export const sys_technologyProjects = {
  pageList: rootPath + "/enterpriseSubsidyTechnologyProject/pageList", // 列表
  saveupdate: rootPath + "/enterpriseSubsidyTechnologyProject/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseSubsidyTechnologyProject/remove/',   // 删除
  detail: rootPath + "/enterpriseSubsidyTechnologyProject/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseSubsidyTechnologyProject/submit",   // 提交
}

// 双创载体认定补贴
export const sys_technologyEnterprise = {
  pageList: rootPath + "/enterpriseSubsidyIncubator/pageList", // 列表
  saveupdate: rootPath + "/enterpriseSubsidyIncubator/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseSubsidyIncubator/remove/',   // 删除
  detail: rootPath + "/enterpriseSubsidyIncubator/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseSubsidyIncubator/submit",   // 提交
}

// 科技型企业补贴
export const sys_technologyBasedEnterprises = {
  pageList: rootPath + "/enterpriseSubsidyTechnologyCompanyProject/pageList", // 列表
  saveupdate: rootPath + "/enterpriseSubsidyTechnologyCompanyProject/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseSubsidyTechnologyCompanyProject/remove/',   // 删除
  detail: rootPath + "/enterpriseSubsidyTechnologyCompanyProject/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseSubsidyTechnologyCompanyProject/submit",   // 提交
}

// 高企营收上台阶奖励兑现
export const sys_technologySubsidyRevenue = {
    pageList: rootPath + "/enterpriseSubsidyRevenue/pageList", // 列表
    saveupdate: rootPath + "/enterpriseSubsidyRevenue/saveOrUpdate", // 新增,编辑
    remove: rootPath + '/enterpriseSubsidyRevenue/remove/',   // 删除
    detail: rootPath + "/enterpriseSubsidyRevenue/detail",   // 获取详情
    commitUrl: rootPath + "/enterpriseSubsidyRevenue/submit",   // 提交
  }

// 创新创业大赛补贴
export const sys_entrepreneurshipSubsidy = {
  pageList: rootPath + "/enterpriseSubsidyEntrepreneurshipCompetition/pageList", // 列表
  saveupdate: rootPath + "/enterpriseSubsidyEntrepreneurshipCompetition/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseSubsidyEntrepreneurshipCompetition/remove/',   // 删除
  detail: rootPath + "/enterpriseSubsidyEntrepreneurshipCompetition/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseSubsidyEntrepreneurshipCompetition/submit",   // 提交
}

// 知识产权运营补贴
export const sys_intellectualproperty = {
  pageList: rootPath + "/propertyOperation/pageList", // 列表
  saveupdate: rootPath + "/propertyOperation/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/propertyOperation/remove/',   // 删除
  detail: rootPath + "/propertyOperation/detail",   // 获取详情
  commitUrl: rootPath + "/propertyOperation/submit",   // 提交
}

// 区级展翼瞪羚独角兽补贴
export const sys_districtlevelSubsidies = {
  pageList: rootPath + "/enterpriseSubsidyDl/pageList", // 列表
  saveupdate: rootPath + "/enterpriseSubsidyDl/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseSubsidyDl/remove/',   // 删除
  detail: rootPath + "/enterpriseSubsidyDl/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseSubsidyDl/submit",   // 提交
}

// 技术合同补贴
export const sys_technicalcontract = {
  pageList: rootPath + "/enterpriseSubsidyTechcontract/pageList", // 列表
  saveupdate: rootPath + "/enterpriseSubsidyTechcontract/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseSubsidyTechcontract/remove/',   // 删除
  detail: rootPath + "/enterpriseSubsidyTechcontract/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseSubsidyTechcontract/submit",   // 提交
}

// 新入库企业补贴
export const sys_enteredenterprises = {
  pageList: rootPath + "/enterpriseSubsidyNewenter/pageList", // 列表
  saveupdate: rootPath + "/enterpriseSubsidyNewenter/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseSubsidyNewenter/remove/',   // 删除
  detail: rootPath + "/enterpriseSubsidyNewenter/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseSubsidyNewenter/submit",   // 提交
}

// 已在库企业补贴
export const sys_enterprisesinstock = {
  pageList: rootPath + "/enterpriseSubsidyAlreadyin/pageList", // 列表
  saveupdate: rootPath + "/enterpriseSubsidyAlreadyin/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseSubsidyAlreadyin/remove/',   // 删除
  detail: rootPath + "/enterpriseSubsidyAlreadyin/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseSubsidyAlreadyin/submit",   // 提交
}

// 研发费用补贴
export const sys_researchcosts = {
  pageList: rootPath + "/enterpriseSubsidyRd/pageList", // 列表
  saveupdate: rootPath + "/enterpriseSubsidyRd/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseSubsidyRd/remove/',   // 删除
  detail: rootPath + "/enterpriseSubsidyRd/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseSubsidyRd/submit",   // 提交
}

// 企业柔性引才
export const sys_flexibletalent = {
  pageList: rootPath + "/enterpriseSubsidyFt/pageList", // 列表
  saveupdate: rootPath + "/enterpriseSubsidyFt/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseSubsidyFt/remove/',   // 删除
  detail: rootPath + "/enterpriseSubsidyFt/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseSubsidyFt/submit",   // 提交
}

// 企业创新创业
export const sys_enterpriseInnovation = {
  pageList: rootPath + "/enterpriseSubsidyIe/pageList", // 列表
  saveupdate: rootPath + "/enterpriseSubsidyIe/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseSubsidyIe/remove/',   // 删除
  detail: rootPath + "/enterpriseSubsidyIe/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseSubsidyIe/submit",   // 提交
}

//高企迁入奖补
export const sys_enterpriseRelocation = {
    pageList: rootPath + "/enterpriseSubsidyMi/pageList", // 列表
    saveupdate: rootPath + "/enterpriseSubsidyMi/saveOrUpdate", // 新增,编辑
    remove: rootPath + '/enterpriseSubsidyMi/remove/',   // 删除
    detail: rootPath + "/enterpriseSubsidyMi/detail",   // 获取详情
    commitUrl: rootPath + "/enterpriseSubsidyMi/submit",   // 提交
    exportExcelTemplate1: rootPath + "/enterpriseSubsidyMi/exportExcelTemplate1",
    exportExcelTemplate2: rootPath + "/enterpriseSubsidyMi/exportExcelTemplate2",

  }

// 高企提质增效
export const sys_highquality = {
  pageList: rootPath + "/enterpriseSubsidyHc/pageList", // 列表
  saveupdate: rootPath + "/enterpriseSubsidyHc/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseSubsidyHc/remove/',   // 删除
  detail: rootPath + "/enterpriseSubsidyHc/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseSubsidyHc/submit",   // 提交
}

//高企研发费用奖励
export const sys_devCost = {
    pageList: rootPath + "/enterpriseSubsidyDc/pageList", // 列表
    saveupdate: rootPath + "/enterpriseSubsidyDc/saveOrUpdate", // 新增,编辑
    remove: rootPath + '/enterpriseSubsidyDc/remove/',   // 删除
    detail: rootPath + "/enterpriseSubsidyDc/detail",   // 获取详情
    commitUrl: rootPath + "/enterpriseSubsidyDc/submit",   // 提交
  }

// 双创载体质量提升补贴
export const sys_improvingSubsidy = {
  pageList: rootPath + "/enterpriseSubsidyCarrier/pageList", // 列表
  saveupdate: rootPath + "/enterpriseSubsidyCarrier/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseSubsidyCarrier/remove/',   // 删除
  detail: rootPath + "/enterpriseSubsidyCarrier/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseSubsidyCarrier/submit",   // 提交
}

// 企业入库奖励
export const sys_warehousingReward = {
  pageList: rootPath + "/enterpriseSubsidyRk/pageList", // 列表
  saveupdate: rootPath + "/enterpriseSubsidyRk/saveOrUpdate", // 新增,编辑
  remove: rootPath + '/enterpriseSubsidyRk/remove/',   // 删除
  detail: rootPath + "/enterpriseSubsidyRk/detail",   // 获取详情
  commitUrl: rootPath + "/enterpriseSubsidyRk/submit",   // 提交
}
